
import { dashboardActions } from "~/store/helpers";
export default {
  props: {
    card: Object,
    data: Array,
    editing: Boolean,
    title: String,
    isOutlined: Boolean,
    id: [String, Number],
  },
  data() {
    return {
      loading: true,
      organizationId: null,
      apiResult: null,
      outlinedStyle: {
        background: "white",
        border: "solid 1px #ced2e0",
      },
      mId: null,
    };
  },
  async mounted() {
    this.mData = this.$props.data;
    this.mId = this.$props.id;

    this.organizationId = localStorage.getItem("organizationId");
    this.apiResult = await this.getQuery({
      organizationId: this.organizationId,
      query: this.card.query_name,
    });
    this.loading = false;
  },
  computed: {
    mData() {
      return this.apiResult?.data ?? [];
    },
    cardName() {
      return this.card.filters.query_name;
    },
  },
  methods: {
    ...dashboardActions,
  },
};
